export default {"src":"/_next/static/media/lockLoginBottom.4ac1c74b.svg","height":32,"width":40};